<template>
    <ul>
      <li style='float: left; display: block; padding: 10px; text-decoration: none'>
        <!-- pc view -->
        <div class="fv ct" style='position: relative; width: 300px; height:300px; margin-bottom: 10px; background: #ffffff; border-style: solid; border-width: 1px;
                border: 1px solid #dddddd; box-shadow: 1px 1px 2px #dddddd' v-if='!mobileView'>
            <div class="fv cc" style='margin-top: 10px; height:130px; background: #ffffff'>
              <img id="imagenPlaceholder" src="/dist/progress-item.gif"  v-show='imagenProducto == null'  style="width:200px; height: 120px;" /> 
              <img id="imagenProducto" :src="imagenProducto" style="width: 200px; height: 120px; object-fit: contain" v-show='imagenProducto != null'/> 
            </div> 
            <div style='width: 100%'>
                <div style='font-size: 14px; color: #656E76; margin-left: 10px; margin-top: 8px; font-weight: 500;'>{{item.Titulo}}</div>
                <ul style='margin-top: 5px; margin-left: 10px; margin-right: 10px; height: 45px; overflow: auto'>
                    <li style='font-size: 9px; color: #656E76;  margin-bottom: 2px' v-for="escala in escalas">&#8226; {{ escala }}</li>
                </ul>
                <div style='font-size: 12px; color: #656E76; margin-left: 10px; margin-top: 5px; font-weight: 500'>{{getAlcance}}</div>
                <ul style='margin-top: 5px; margin-left: 10px; height: 45px; overflow: auto'>
                    <li style='font-size: 9px; color: #656E76; margin-bottom: 2px' v-for="itemAlcance in itemsAlcance">&#8226; {{ itemAlcance }}</li>
                </ul>
              </div> 
        </div>




        <!-- mobile view -->
        <!-- <div  v-if='mobileView' style="width: 90vw; height:100px; margin-bottom: 10px; background: #ffffff;  
              border-style: solid; border-width: 1px; border: 1px solid #dddddd; box-shadow: 1px 1px 2px #dddddd; display: flex; flex-direction: row;
              align-items: flex-start; justify-content: flex-start;">
          <div class="fh cc" style="width: 30%; height: 100%;">
            <img id="imagenProducto" :src="imagenProducto" style="height: 70%"/> 
          </div>
          <div class="fv lc" style="width: 68%; height: 100%;">
            <div class="fh cc" style="margin-left: 10px; font-size: 15px; color:#5D6770; font-weight: 500">{{item.Nombre}}</div>
            <div class="fh cc" style="margin-left: 10px; font-size: 11px; color:#5D6770; margin-top: 10px">{{item.Observacion}}</div>
            <div class="fh lc" style="width: 100%; margin-top: 10px">
                <div class="fh lc" style="width: 50%; margin-left: 10px; font-size: 11px; color:#5D6770; font-weight: 500;">P. Mín: {{getPedidoMinimo}}</div>
                <div class="fh lc" style="width: 50%; margin-left: 10px; font-size: 11px; color:#5D6770; font-weight: 500;">P. Máx: {{getPedidoMaximo}}</div>
            </div> 
          </div>
        </div> -->


      </li>
    </ul>
  </template>
  
   
  <script>
    import axios from 'axios'
  
    
    export default {
      name: 'item-promocion',
      props: ['item'],
  
      data() {
        return {
          mobileView:false,
          escalas:[],
          itemsAlcance:[]
        }
      },  
  
      watch: {
        item: {
          immediate: true,
          handler  () {
          }
        }
      },

      computed: {

        getAlcance() {
          var s1 = ''  
          this.escalas = this.item.TextoEscala.split('\n');
          this.escalas.pop()
          if (this.item.AfectaA == 1) {
            s1 = 'En los productos:'  
            this.item.Productos.forEach((item)=> {
              this.itemsAlcance.push(item.Nombre)    
            });
          }
          else if (this.item.AfectaA == 2) {
            this.item.CategoriaN1.forEach((item)=> {
              this.itemsAlcance.push(item.Nombre)    
            });
            s1 = 'En productos de la linea:'  
          }
          else if (this.item.AfectaA == 3) {
            this.item.CategoriaN2.forEach((item)=> {
              this.itemsAlcance.push(item.Nombre)    
            });
            s1 = 'En productos de la linea:'  
          }
          return s1
        },


        imagenProducto() {
          if ((this.item.Imagen != null)  && (this.item.Imagen.length > 0)) {
            return this.item.Imagen
          }
          else {
            return '/dist/placeholder-producto.png'
          }
        } 
        
      },
  
      methods: {

        onResize() {
          if (window.innerWidth > 600) {
            this.mobileView=false;
          }
          else {
            this.mobileView=true;
          }
        }
    },


    mounted() {
      this.onResize()
    },

    created() {
      window.addEventListener('resize', this.onResize)
    },

    beforeDestroy() {
      window.removeEventListener('resize', this.onResize)
    }
   
    }
  </script>
  
  
  <style scoped>
  
  * {
    margin:  0;
    padding: 0;
  }
 
  
  
  #oblea {
    width: 630px;
    height:70px;
    margin-bottom: 10px;
    background: #ffffff;  
    border-style: solid;
    border-width: 1px;
    border: 1px solid #dddddd;
    box-shadow: 1px 1px 2px #dddddd;
    display: flex;
    align-items: flex-start; 
  }
  
  #titulo{
    font-size: 14px;
    color: #656E76;
    margin-top: 8px;
    font-weight: 500;
  }
  
  #descrip{
    font-size: 9px;
    color: #656E76;
    height: 12px;
    margin-top: 5px;
    margin-bottom: 10px;
  }
  
  .label{
    font-size: 10px;
    color: #656E76;
    font-weight: bold;
    background-color: #ffffff;
    width: 85px;
    float: left;
  }
  
  .value{
    font-size: 10px;
    color: #656E76;
    width: 70px;
    background-color: #ffffff;
    float: left;
  }
  
  #label-subtotal{
    font-size: 10px;
    font-weight: bold;
    color: #656E76;
    margin-left: 10%;
    width: 90px;
    background-color: #ffffff;
    float: left;
  }


    /* width */
    ::-webkit-scrollbar {
        width: 5px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        box-shadow: inset 0 0 5px #dddddd; 
        border-radius: 10px;
    }
    
    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #cccccc; 
        border-radius: 10px;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #bbbbbb; 
    }

  
 </style>




// WEBPACK FOOTER //
// src/components/views/descuentos/itemDescuento.vue